import React, { Component } from 'react';
import { FormattedMessage  } from 'react-intl'
import PropTypes from 'prop-types';
import { InputNumber, Button } from 'antd';
import { CheckOutlined} from '@ant-design/icons';

class PercentInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
          disableUpdate: true,
        };

        this.supplies_level = 100;
      }

      onChange(value) {
        this.setState({disableUpdate: false});
        this.supplies_level = value;
      }

      onUpdate(value) {
        this.props.onUpdate(this.supplies_level);
        this.setState({disableUpdate: true});
      }
    
    render() {
      return (
        <div className = "range-picker">
            <b><FormattedMessage id="MaxLevel"/></b>&nbsp;&nbsp;
            <InputNumber
                size="small"
                defaultValue={this.props.minimalLevel === -1 ? 100 : this.props.minimalLevel}
                min={0}
                max={100}
                formatter={value => `${value}%`}
                parser={value => value.replace('%', '')}
                onChange={(value) => this.onChange(value)}
            />
            &nbsp;&nbsp;
            <Button size="small" type="primary" disabled = {this.state.disableUpdate} onClick={() => this.onUpdate()}><CheckOutlined/></Button>
        </div>
    );
  }
}

PercentInput.propTypes = {
  onUpdate: PropTypes.func.isRequired,
};

export default PercentInput;